import {ViewType} from "../../../gd/const/views/view-type"
import ProjectViews from "../project-views"
import {ViewTypeConfigs} from "../../../gd/const/views/view-type-config"
import ProjectViewFactory from "../factory"

export default function projectViews_normalize(projectViews: ProjectViews) {
    // if expenses enabled and no PROJECT_EXPENSES view then add it
    /*const expensesView = projectViews.getBySystemType(ViewType.PROJECT_EXPENSES)[0]
    if (projectViews.project.properties.expenses && !expensesView) {
        projectViews.createView({
            name        : ViewTypeConfigs[ViewType.PROJECT_EXPENSES]?.name,
            systemType  : ViewType.PROJECT_EXPENSES,
            isPinned    : true
        })
    }*/

    // add link view for link projects (is required for URL edit)
    if (projectViews.project.isLink) {
        projectViews.add(ProjectViewFactory({
            name        : ViewTypeConfigs[ViewType.PROJECT_LINK]?.name,
            systemType  : ViewType.PROJECT_LINK,
            isPinned    : true
        }, projectViews))
        projectViews.sort()
    }
}